import { translate } from "app/filters/i18nFilter";
import { StyledSingleSelectDDItemText } from "app/pages/sales-intelligence/common-components/dropdown/styles";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import { DROPDOWN_ID } from "app/pages/sales-intelligence/sub-modules/signals/components/shared/SignalTemplatesDropdown/const";
import { StyledSignalDescription } from "app/pages/sales-intelligence/sub-modules/signals/components/shared/styles";
import type SignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalFilters";
import type SignalTemplate from "app/pages/sales-intelligence/sub-modules/signals/models/templates/SignalTemplate";
import { StyledDetailedItem, StyledItemTitleWrapper } from "./styles";
import type { ReactElement } from "react";

type Props = {
    template: SignalTemplate<SignalFilters>;
    tag?: ReactElement;
};

const SignalTemplateDetailedDropdownItem = ({ template, tag }: Props) => {
    const renderItemHeader = () => {
        const title = (
            <I18n
                data-automation={`${DROPDOWN_ID}-item-text`}
                element={StyledSingleSelectDDItemText}
                translatable={template.name}
            />
        );

        if (tag) {
            return (
                <StyledItemTitleWrapper>
                    {title}
                    {tag}
                </StyledItemTitleWrapper>
            );
        }

        return title;
    };

    return (
        <StyledDetailedItem>
            {renderItemHeader()}

            <StyledSignalDescription>{translate(template.description.key)}</StyledSignalDescription>
        </StyledDetailedItem>
    );
};

export default SignalTemplateDetailedDropdownItem;
